import config from 'constants/config'

/**
 * Leaf flag for Lux Loyalty inside Agent Hub.
 * Kept out of agentHubSelectors so loyalty selectors can use it without
 * pulling commissionMap via agentHubSelectors.
 */
export const isLuxLoyaltyEnabledInAgentHub = config.agentHub.isEnabled && config.LUX_LOYALTY_ENABLED
